import { useAtom } from 'jotai';
import { Box, FormControlLabel, Switch } from '@mui/material';
import { CuboidBase, CuboidState } from '../../types';

type HidePointsOutsideCuboidControlProps<CuboidT extends CuboidBase> = {
  cuboidState: CuboidState<CuboidT>;
};

export const HidePointsOutsideCuboidControl = <CuboidT extends CuboidBase>({
  cuboidState,
}: HidePointsOutsideCuboidControlProps<CuboidT>) => {
  const [isCuboidVisibilityBoxEnabled, setIsCuboidVisibilityBoxEnabled] = useAtom(
    cuboidState.isCuboidVisibilityBoxEnabled
  );
  return (
    <Box sx={{ marginLeft: 5 }}>
      <FormControlLabel
        sx={{
          color: '#fff',
          padding: '5px 10px 5px 0px',
          borderRadius: '4px',
          border: '2px solid #fff',
        }}
        control={
          <Switch
            sx={{ marginLeft: '5px', marginRight: '5px', color: '#fff' }}
            checked={isCuboidVisibilityBoxEnabled}
            onChange={() => setIsCuboidVisibilityBoxEnabled((current) => !current)}
          />
        }
        label="Hide points outside"
      />
    </Box>
  );
};
